import { render, staticRenderFns } from "./resource-selector.vue?vue&type=template&id=5190158c&"
import script from "./resource-selector.vue?vue&type=script&lang=js&"
export * from "./resource-selector.vue?vue&type=script&lang=js&"
import style0 from "./resource-selector.vue?vue&type=style&index=0&id=5190158c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports